import React from 'react';
import { Transaction } from '@alien-platform/bo-core';

import { Row } from '@/types/general';
import { HorizontalTable } from '@/components/core/horizontal-table';

export function PlayerDetailsTable({ transactionData }: { transactionData: Transaction }): React.JSX.Element {
  const tableData: Row[] = [
    {
      label: {
        text: 'Operator',
      },
      value: {
        text: `${transactionData?.parentOpTitle ? transactionData?.parentOpTitle : transactionData?.opTitle}`,
      },
    },
    {
      label: {
        text: 'Brand',
      },
      value: {
        text: `${transactionData.parentOpId ? transactionData.opTitle : '-'}`,
      },
    },
    {
      label: {
        text: 'Player',
      },
      value: {
        text: transactionData?.player.username,
      },
    },
    {
      label: {
        text: 'Affiliate',
      },
      value: {
        text: transactionData?.player.affId,
      },
    },
    {
      label: {
        text: 'Account Holder Name',
      },
      value: {
        text: ``,
      },
    },
    {
      label: {
        text: 'Bank Name',
      },
      value: {
        text: ``,
      },
    },
  ];

  return <HorizontalTable header="Player Details" tableData={tableData} />;
}
